// THIS FILE IS AUTOMATICALLY GENERATED
import AppBar from './AppBar/AppBar.vue'
import AppCss from './AppCss/AppCss.vue'
import Autocomplete from './Autocomplete/Autocomplete.vue'
import Button from './Button/Button.vue'
import Buttons from './Buttons/Buttons.vue'
import Code from './Code/Code.vue'
import Container from './Container/Container.vue'
import Heading from './Heading/Heading.vue'
import Input from './Input/Input.vue'
import Paragraph from './Paragraph/Paragraph.vue'
import Text from './Text/Text.vue'
import Theme from './Theme/Theme.vue'

// Install components globally
const install = Vue => {
  Vue.component('AppBar', AppBar)
  Vue.component('AppCss', AppCss)
  Vue.component('Autocomplete', Autocomplete)
  Vue.component('Button', Button)
  Vue.component('Buttons', Buttons)
  Vue.component('Code', Code)
  Vue.component('Container', Container)
  Vue.component('Heading', Heading)
  Vue.component('Input', Input)
  Vue.component('Paragraph', Paragraph)
  Vue.component('Text', Text)
  Vue.component('Theme', Theme)
}

// Export library as a plugin, and individual components
export default { install }
export {
  AppBar,
  AppCss,
  Autocomplete,
  Button,
  Buttons,
  Code,
  Container,
  Heading,
  Input,
  Paragraph,
  Text,
  Theme,
}
